import { render, staticRenderFns } from "./MyReservationsPage.vue?vue&type=template&id=5b19cf6f&scoped=true&"
import script from "./MyReservationsPage.vue?vue&type=script&lang=js&"
export * from "./MyReservationsPage.vue?vue&type=script&lang=js&"
import style0 from "./MyReservationsPage.vue?vue&type=style&index=0&id=5b19cf6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19cf6f",
  null
  
)

export default component.exports